module.exports = __webpack_public_path__ + "static/media/privacy-policy.78fe50f8.md";